import type { StepProps } from '../OBWWizard';
import { WELCOME_CONTENT } from '../content/welcome';

// Phase 5c.5 (ADR-030 D2 Step 2) — branded heading + journey-aware copy +
// "Get started" CTA + steps-preview list (mirrors nexa-demo welcome step).
//
// ADR-076 §4 L5 — per-journey copy is DATA, not `if (journeyId === …)`
// branching. The renderer does a pure lookup into WELCOME_CONTENT
// (content/welcome.ts); it does NOT sniff the mount context.

export function StepWelcome({ journeyId, onNext }: StepProps) {
  const content = WELCOME_CONTENT[journeyId] ?? WELCOME_CONTENT.default;

  return (
    <div className="obw-step-content">
      <h2 className="obw-title">{content.heading}</h2>
      <p className="obw-subtitle">{content.body}</p>

      {content.showRequiredNotice && (
        <div className="obw-required-notice" role="note">
          <span aria-hidden="true">⚠️</span>
          <span>
            Plan, payment, and domain authorisation are required to activate your account. You can
            exit and resume — but the account is not active until you complete those steps.
          </span>
        </div>
      )}

      {content.steps.length > 0 && (
        <ol className="obw-steps-preview" aria-label="What we'll cover">
          {content.steps.map((s) => (
            <li key={s.num}>
              <span className="obw-step-num" aria-hidden="true">{s.num}</span>
              <span>
                <strong style={{ color: 'var(--text)' }}>{s.label}</strong>
                <br />
                <span style={{ color: 'var(--text-dim)', fontSize: '14px' }}>{s.description}</span>
              </span>
            </li>
          ))}
        </ol>
      )}

      {content.showTimeFootnote && (
        <p className="obw-subtitle" style={{ fontSize: '14px' }}>
          This takes about 10–15 minutes. You can pause and resume at any time.
        </p>
      )}

      <button type="button" className="obw-btn-primary" onClick={() => onNext({})}>
        Get started →
      </button>
    </div>
  );
}
